import { render, staticRenderFns } from "./VideoPresence.vue?vue&type=template&id=0180123e&"
import script from "./VideoPresence.vue?vue&type=script&lang=js&"
export * from "./VideoPresence.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports